<script>
export default {
	name: 'Story',
	props: {
		size: String,
		type: String,
		image: String,
		link: {
			type: String,
			default: '/'
		},
	},
	computed: {
		storyClass() {
			return `${this.size} ${this.type}`
		},
		imageUrl() {
			if (!this.image) return
			let url = require(`../assets/main/${this.image}`)
			return {backgroundImage: `url(${url})`}
		}
	}
}
</script>



<template>
<router-link :to="link" class="story" :class="storyClass"  v-if="type !== 'center'">
	<div class="image" :style="imageUrl"></div>
	<div class="mask">
		<slot name="title"></slot>
		<slot name="text"></slot>
	</div>
	<div class="border"></div>
</router-link>
<a href="http://twd.rt.ru/" target="_blank" class="story" :class="storyClass" v-else onclick="ga('send', 'event', 'link', 'story9', 'rostelekom')">
	<div class="image" :style="imageUrl"></div>
	<div class="mask">
		<slot name="title"></slot>
		<slot name="text"></slot>
	</div>
	<div class="border"></div>
</a>
</template>

<style lang="less" scoped>
@import "../styles/colors.less";
@import "../styles/fonts.less";

.story {
	float: left;
	position: relative;
	overflow: hidden;
	cursor: pointer;
	background: #000;
}

.small {
	width: 25vw;
	height: 25vw;
}

.big {
	width: 50vw;
	height: 25vw;
}

.image {
	width: 100%;
	height: 100%;
	position: absolute;
	background-size: cover;
	background-position: center;
	transition: all 300ms ease;
}

.mask {
	width: 100%;
	height: 100%;
	position: absolute;
	background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%);
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	color: #fff;
}

h2 {
	width: 90%;
	margin: 0 auto;
	font-size: 23px;
}

p {
	width: 90%;
	margin: 0 auto;
	padding-bottom: 5vh;
	font-size: 23px;
	font-family: @fontLava;
	font-weight: 600;
	transition: all 200ms ease;
}

.story:hover .image {
	transform: scale(1.04);
	opacity: 0.5;
}

.half .image {
	height: 50%;
}

.half .mask {
	height: 50%;
	top: 50%;
	justify-content: flex-start;
	background: #fff;
	color: #000;
	box-sizing: border-box;
	border-right: 1px solid rgba(0,0,0,0.1);
}

.half h2 {
	color: @red;
	padding: 1vh 0;
	font-size: 15px;
}

.half p {
	font-size: 18px;
	font-weight: 400;
}

.border {
	width: 100%;
	height: 100%;
	position: absolute;
	pointer-events: none;
	box-sizing: border-box;
	border: 0px solid @red;
	transition: all 200ms ease;
}

.story.half:hover {
	.border {
		border: 5px solid @red;
		opacity: 1;
	}

	.image {
		transform: scale(1.04);
		opacity: 1;
	}

	p {
		color: @red;
	}
}


.center {
	.mask {
		justify-content: center;
		text-align: center;
	}

	h2 {
		color: @red;
		font-size: 14px;
		padding: 1vh 0;
	}

	.border {
		box-sizing: border-box;
		border: 14px solid #fff;
	}
}

.center:hover .border {
	border: 14px solid @red;
}



@media only screen and (max-width: 1240px) {


.mask {
	h2 {
		font-size: 15px;
		padding-bottom: 1vh;
	}
	p {
		font-size: 15px;
		padding-bottom: 2vh;
	}
}


}



@media only screen
and (max-device-width: 640px),
only screen and (max-device-width: 736px),
only screen and (max-width: 480px) {

.small {
	width: 100vw;
	height: 80vw;
}

.big {
	width: 100vw;
	height: 80vw;
}


}

</style>



// WEBPACK FOOTER //
// AppStory.vue?227f0138